<!--
 * @Author: 范向玲
 * @Date: 2022-10-08 16:58:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-27 13:42:47
 * @Description:
 * @FilePath: \web\src\components\DataManagement\tradeQuantity\component\search.vue
-->
<template>
  <div class="tradeQuantity-search">
    <section class="search-btns">
      <span v-for="(item, i) in tradeNationList" :key="i" :class="requestParams.source === item.name ? 'active' : ''"
        @click="changeTradeNation(item.name)">{{ item.label }}</span>
    </section>
    <div class="formItem">

      <!-- <div class="search-item">
        <span>贸易国：</span>
        <a-select v-model:value="requestParams.source" placeholder="请选择贸易国" @change="changeTradeNation">
          <a-select-option v-for="item in tradeNationList" :key="item.name" :value = 'item.name'>
            {{ item.name }}
          </a-select-option>
          <template #suffixIcon>
            <CaretDownOutlined />
          </template>
</a-select>
</div> -->
      <div class="search-item">
        <span>矿种：</span>
        <a-select v-model:value="requestParams.commodity" placeholder="请选择矿种" @change="changeCommodity">
          <a-select-option v-for="item in minerals" :key="item.commodity" :value="item.commodity">
            {{ item.commodity }}
          </a-select-option>
          <template #suffixIcon>
            <CaretDownOutlined />
          </template>
        </a-select>
      </div>
      <div class="search-item">
        <span>贸易品：</span>
        <a-select v-model:value="requestParams.tradeCode" placeholder="请选择贸易品">
          <a-select-option v-for="item in tradeGoodsList" :key="item.name" :value="item.value">
            {{ item.name }}
          </a-select-option>
          <template #suffixIcon>
            <CaretDownOutlined />
          </template>
        </a-select>
      </div>
      <!-- <div class="search-item">
        <span>进出口：</span>
        <a-select v-model:value="requestParams.importsType" placeholder="请选择进出口">
          <a-select-option v-for="item in importsTypeList" :key="item.importsType">
            {{ item.name }}
          </a-select-option>
          <template #suffixIcon>
            <CaretDownOutlined />
          </template>
        </a-select>
      </div>
      <div class="search-item">
        <span>贸易伙伴：</span>
        <a-input placeholder="请输入贸易伙伴" v-model:value="requestParams.propName" />
      </div> -->

      <div class="search-item search-item-time">
        <span>时间选择：</span>
        <!-- <a-range-picker v-model:value="requestParams.reportDate" format="YYYY" :mode="['year', 'year']"
          @change="changeDate" /> -->
           <a-date-picker format="YYYY" mode="year"
          :value="requestParams.startYear ? moment(requestParams.startYear) : null" :open="open1"
          @openChange="openChange1" @panelChange="(e) => panelChange('startYear', e)"
          @change="(e) => changeYear('startYear', e)" />
        <a-date-picker format="YYYY" mode="year" :value="requestParams.endYear ? moment(requestParams.endYear) : ''"
          :open="open2" @openChange="openChange2" @panelChange="(e) => panelChange('endYear', e)"
          @change="(e) => changeYear('endYear', e)" />
        <!-- <a-range-picker v-model:value="requestParams.reportDate" format="YYYY" :mode="['year', 'year']" @change="changeDate" /> -->
      </div>
    </div>

    <slot name="btns"> 
      <div class="btn-wrapper" :class="searchType === 'left' ? 'btn-wrapper-left' : ''">
        <div class="reset-btn btn-item search-item" @click="resetSearch">重置</div>
        <div class="search-btn btn-item" @click="submitSearch()">查询</div>
      </div>
    </slot>
  </div>
</template>

<script setup>
import * as dayjs from 'dayjs';
import { CaretDownOutlined, } from '@ant-design/icons-vue';
import { computed, toRefs, ref, defineProps, defineEmits, watch, onMounted, defineExpose, } from 'vue';
import { getDicInfoApi, } from '@/api/drillLibrary/utilsApi';
import { GET_TRADE_QUANTITY_NATION, GET_TRADE_QUANTITY_GOODS, GET_MINERALS, } from '@/store/modules/actions/tradeQuantity';
import moment from 'moment';
import { useStore, } from 'vuex';

const props = defineProps({
  storeModule: {
    type: String,
    default: 'tradeQuantity',
  },
  searchType: {
    type: String,
    default: 'right',
  },
  hgMsg: {
    type: String,
    default: 'right',
  },
  type:{
    type:String,
    default: 'cl',
  }
});

const open1 = ref(false), open2 = ref(false),
  year = ref(moment());

const emit = defineEmits(['submit',]);

const { storeModule, } = toRefs(props);

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const tradeQuantityState = computed(() => state[storeModule.value]);
const { minerals, requestParams, tradeNationList, tradeGoodsList, } = toRefs(tradeQuantityState.value);

// action
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || storeModule.value}/${methods}`, params);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || storeModule.value}/${methods}`, params);

const openChange1 = (status) => {
  if (status) {
    open1.value = true;
  } else {
    open1.value = false;
  }
};
const openChange2 = (status) => {
  if (status) {
    open2.value = true;
  } else {
    open2.value = false;
  }
};
const panelChange = (name, value) => {
  requestParams.value[name] = moment(value).format('YYYY')
  year.value = value;
  name === 'startYear' ? open1.value = false : open2.value = false
};
const changeYear = (name, value) => {
  requestParams.value[name] = value && moment(value).format('YYYY') || value
  year.value = value;
}
// ref
const stages = ref(null);
const explorationList = ref(null);

getDicInfoApi('dicType=Stage').then((res) => {
  let list = [];

  res.data.forEach((ele, i) => {
    list.push({ id: i, name: ele, });
  });
  list.unshift({ id: null, name: '全部', });
  stages.value = list;
});
getDicInfoApi('dicType=Exploration').then((res) => {
  let list = [];

  res.data.forEach((ele, i) => {
    list.push({ id: i, name: ele, });
  });
  list.unshift({ id: null, name: '全部', });
  explorationList.value = list;
});

onMounted(() => {
  dispatch(null, GET_TRADE_QUANTITY_NATION);
});


const changeCommodity = (value) => {
  commit(null, 'setRequestParams', { commodity: value, tradeCode: null, });
  dispatch(null, GET_TRADE_QUANTITY_GOODS);
};

/**
 * @description 修改日期
 */
// const changeDate = (value) => {
//   requestParams.value.startYear = value ? dayjs(value[0]).format('YYYY-MM-DD') : '';
//   requestParams.value.endYear = value ? dayjs(value[1]).format('YYYY-MM-DD') : '';
//   requestParams.value.reportDate = value;
// };

/**
 * @description 查询
 */
const submitSearch = () => {
  requestParams.value.page = 1;
  emit('submit', requestParams.value);
};

/**
 * @description 重置
 */
const resetSearch = () => {
  commit(null, 'clear');
  submitSearch();
};

const changeTradeNation = (value) => {
  commit(null, 'setRequestParams', { source: value, commodity: null, tradeCode: null,startYear:null,endYear:null });
  dispatch(null, GET_MINERALS);
  dispatch(null, GET_TRADE_QUANTITY_GOODS);
  requestParams.value.source = value;
  submitSearch();
};

defineExpose({ resetSearch, });


watch(tradeQuantityState.value, (val, old) => {
  if (val.tradeNationList && val.tradeNationList.length > 0 && !requestParams.value.source) {
    // requestParams.value.source = val.tradeNationList[0].name;
    submitSearch();
    changeTradeNation(val.tradeNationList[0].name);
  }
}, {
  deep: true,
  immediate: true,
});
</script>

<style lang="scss">
.tradeQuantity-search {
  width: 100%;
  display: block;
  position: relative;

  .search-btns {
    position: absolute;
    padding-left: 2.5rem;
    left: 0;
    top: -0.4rem;
    width: 100%;
    height: .4rem;
    display: flex;
    border-bottom: 0.03rem solid rgba(179, 150, 92, 0.6);

    >span {
      padding: .1rem .2rem .1rem .2rem;
      cursor: pointer;
      margin: 0 .02rem;
      border-radius: .03rem .03rem 0 0;
      background-color: rgba(179, 150, 92, .05);

      &.active {
        background-color: rgba(179, 150, 92, 0.6)
      }
    }
  }

  .formItem {
    display: flex;
    width: 100%;

    flex-wrap: wrap;
    height: 0.51rem;
    padding: 0.13rem 0.1rem;

    .search-item {
      // display: flex;
      align-items: center;
      // display: inline-block;
      width: 2.5rem;
      height: 0.34rem;
      line-height: 0.34rem;
      margin-right: 0.05rem;

      >span {
        display: inline-block;
        height: 100%;
        // width: 1.3rem;
        text-align: right;
        font-size: 0.14rem;
      }

      .ant-input,
      .ant-input-number,
      .ant-select {
        display: inline-block;
        width: calc(100% - .6rem);
        color: white;
        background-color: transparent;
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        border: transparent;
        background-color: rgba(91, 76, 39, 0.4);

        &.ant-input-affix-wrapper-foused {
          border: none;
        }

        .ant-select-selection-placeholder,
        .ant-select-selection-item {
          padding-right: 0;
          background: transparent;
          border: 0;

          .anticon {
            color: #fff;
          }
        }

        .ant-select-selector {
          background: transparent;
          border: 0;
        }

        .ant-select-arrow {
          color: #fff;

          .ant-select-suffix {
            width: 0.12rem;
            height: 0.12rem;
            margin-top: .02rem;
          }
        }
      }

      .ant-input-number .ant-input-number-handler-wrap {
        background: rgba(91, 76, 39, 0.4);
        border: .01rem solid rgba(91, 76, 39, 0.4);
      }

      .ant-input-number:hover .ant-input-number-handler-wrap {
        background: rgba(91, 76, 39, 0.4);
        border: .01rem solid rgba(91, 76, 39, 0.4);
      }

      .mineral {
        display: inline-block;
        width: 100%;
        height: 100%;
        position: relative;

        .mineral-type-cascader {
          height: 0.34rem;
          font-size: 0.14rem;
          background-color: rgba(91, 76, 39, 0.4);
          padding-left: 0.11rem;
        }
      }

      .double {
        width: calc(50% - 0.8rem);
        margin: 0 0.05rem;
      }

      .ant-radio-wrapper {
        span {
          color: #fff;
        }
      }
    }

    .search-item-time {
      width: 4rem;

   

      .ant-calendar-picker-input {
        width: 100%;
      }

      .ant-calendar-picker {
        width: 1.5rem;
        margin-right: 0.1rem;
      }
    }
  }

  .btn-wrapper {
    position: absolute;
    right: 0rem;
    bottom: 0.05rem;
    height: 0.32rem;
    line-height: 0.32rem;
    margin-left: 0.2rem;
    color: #ffffff;
    display: flex;
    padding: 0;
    width: 3rem;
    justify-content: flex-end;

    .btn-item {
      width: 0.9rem;
      text-align: center;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .reset-btn {
      // background-color: #535962;
      background-image: url(~@/static/images/dataManagement/reset_btn.png);
      background-size: 100% 100%;
    }

    .search-btn {
      // background-color: #efb227;
      background-image: url(~@/static/images/dataManagement/submit_btn.png);
      background-size: 100% 100%;
      margin-left: 0.05rem;
    }
  }

  .btn-wrapper-left {
    right: 2.5rem;
  }
}
</style>
